export enum DuvodZruseniUzivatele {
	ODEBRANI_ADMINISTRATOREM_SUBJEKTU = 'ODEBRANI_ADMINISTRATOREM_SUBJEKTU',
	JINE = 'JINE'
}
